// capStored.js — Onda 1 (anti-travamento). Teto no resultado de tool RETIDO na
// memória residente da mensagem (não confundir com appendCapped, que capa o
// acumulador VIVO de streaming).
//
// O problema: SessionWorkspace guarda `result: String(evt.result)` inteiro em cada
// mensagem de tool. Um read_file de arquivo grande, um grep de milhares de linhas
// ou um artefato gigante ficam residentes por megabytes — a sessão longa cresce
// monotônica rumo ao teto de 2GB do renderer (→ OOM/trava). O corte de render
// (ToolCallBlock, 16 linhas) alivia o DOM, mas NÃO a RAM: a string cheia continua
// pendurada na mensagem.
//
// Este helper capa o que é ARMAZENADO. O resultado real já foi consumido pelo
// modelo naquele turno (o contexto do próximo turno é reconstruído/truncado à
// parte, ver HRN2 em agentLoop.js), então capar o texto residente do card NÃO
// afeta correção — só o que fica pendurado na RAM da UI.
//
// Mantém CABEÇA + CAUDA (o começo de um resultado costuma ser o mais útil — cabeçalho
// de erro, primeiras linhas; a cauda pega o status final), com um marcador do meio.
// PURO, sem I/O.

// 64 KB por resultado: qualquer resultado legítimo de card cabe folgado; só a
// patologia (MB de saída de uma tool) é cortada.
export const STORED_RESULT_MAX_CHARS = 64 * 1024;

/**
 * Capa `str` a `max` chars mantendo cabeça e cauda, com um marcador do que caiu no
 * meio. Retorna a própria string quando já cabe (sem alocação nova).
 * @param {string} str
 * @param {number} [max]
 * @returns {string}
 */
export function capStored(str, max = STORED_RESULT_MAX_CHARS) {
  const s = typeof str === 'string' ? str : String(str ?? '');
  if (s.length <= max) return s;
  const marker = `\n…[${s.length - max} chars cortados — resultado completo já foi para o modelo]…\n`;
  // Se o marcador não cabe (misconfig — o default é 64KB), devolve a cabeça crua.
  if (marker.length >= max) return s.slice(0, max);
  const budget = max - marker.length;
  const head = Math.ceil(budget * 0.6); // cabeça pega mais (cabeçalho de erro, 1as linhas)
  const tail = budget - head;
  return s.slice(0, head) + marker + s.slice(s.length - tail);
}
